var _a;
export var reduxKey = '@@compliantLocalStorage';
export var CompliantLocalStorageKeys;
(function (CompliantLocalStorageKeys) {
    CompliantLocalStorageKeys["RECENT_COLORS"] = "custombox.recent.colors";
    CompliantLocalStorageKeys["INTENTS"] = "intents";
    CompliantLocalStorageKeys["INTENTS_OTHER"] = "intents_other";
    CompliantLocalStorageKeys["STATUS_SUBMIT_COUNTER"] = "statusUpdateSubmitCounter";
    CompliantLocalStorageKeys["FEDOPS_SESSIONID"] = "fedops.logger.sessionId";
    CompliantLocalStorageKeys["CHATDB"] = "chatDB";
    CompliantLocalStorageKeys["EDITOR_DRAFTS"] = "editorDrafts";
    CompliantLocalStorageKeys["NC_DELETE_ON_REPLY"] = "ncDeleteOnReply";
    CompliantLocalStorageKeys["DO_NOT_SHOW_AGAIN"] = "confirm.modal.do.not.show";
    CompliantLocalStorageKeys["COMMENT_REACTIONS"] = "commentReactions";
})(CompliantLocalStorageKeys || (CompliantLocalStorageKeys = {}));
export var CompliantCategories;
(function (CompliantCategories) {
    CompliantCategories["ESSENTIAL"] = "essential";
    CompliantCategories["FUNCTIONAL"] = "functional";
    CompliantCategories["MARKETING"] = "marketing";
    CompliantCategories["ANALYTICS"] = "analytics";
})(CompliantCategories || (CompliantCategories = {}));
export var LocalStorageCategoryTypeConfig = (_a = {},
    // essential
    _a[CompliantLocalStorageKeys.INTENTS] = CompliantCategories.ESSENTIAL,
    _a[CompliantLocalStorageKeys.INTENTS_OTHER] = CompliantCategories.ESSENTIAL,
    _a[CompliantLocalStorageKeys.CHATDB] = CompliantCategories.ESSENTIAL,
    _a[CompliantLocalStorageKeys.FEDOPS_SESSIONID] = CompliantCategories.ESSENTIAL,
    _a[CompliantLocalStorageKeys.DO_NOT_SHOW_AGAIN] = CompliantCategories.ESSENTIAL,
    // functional
    _a[CompliantLocalStorageKeys.RECENT_COLORS] = CompliantCategories.FUNCTIONAL,
    _a[CompliantLocalStorageKeys.STATUS_SUBMIT_COUNTER] = CompliantCategories.FUNCTIONAL,
    _a[CompliantLocalStorageKeys.EDITOR_DRAFTS] = CompliantCategories.FUNCTIONAL,
    _a[CompliantLocalStorageKeys.NC_DELETE_ON_REPLY] = CompliantCategories.FUNCTIONAL,
    _a[CompliantLocalStorageKeys.COMMENT_REACTIONS] = CompliantCategories.FUNCTIONAL,
    _a);
//# sourceMappingURL=constants.js.map